import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
// Create context with a generic parameter
var ConfigContext = createContext(null);
// Make the component generic
function ConfigProvider(_a) {
    var children = _a.children, config = _a.config;
    return (_jsx(ConfigContext.Provider, { value: { config: config !== null && config !== void 0 ? config : {} }, children: children }));
}
// Update the hook to be generic
function useConfigContext() {
    var context = React.useContext(ConfigContext);
    if (!context) {
        throw new Error('useConfigContext must be used within ConfigProvider');
    }
    return context;
}
export { ConfigProvider, useConfigContext };
